export default __webpack_public_path__ + "static/media/icon-transparent.eaa90182.png";